// filepath: src/components/POS/payment/PaymentPanel.js
import React from "react";
import { PAYMENT_METHODS } from "../../../../constant/paymentMethod";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { MdOutlineCreditCard } from "react-icons/md";
import { LuScanLine } from "react-icons/lu";
import { useTheme } from "../../../CommonComponents/ThemeProvider";

/**
 * PaymentPanel
 * - Handles payment method selection
 * - Provides Quick Cash options for faster input
 * - Calculates change and validates payment
 * - Calls onPay when Place Order is clicked
 */
export default function PaymentPanel({ total, cart, onPay, paymentMethod, setPaymentMethod }) {
    const { currentTheme } = useTheme();
    // Icon mapping for each payment method
    const methodIcons = {
        cash: <HiOutlineCurrencyDollar className="w-4.5 h-4.5 mr-0.5" />,
        ewallet: <MdOutlineCreditCard className="w-4.5 h-4.5 mr-0.5" />,
        scan: <LuScanLine className="w-4.5 h-4.5 mr-0.5" />,
    };
    const methodTooltips = {
        cash: "Pay with cash",
        ewallet: "Pay using an e-wallet",
        scan: "Scan QR code to pay",
    };

    return (
        <aside className="w-72 rounded-xl shadow-md hover:shadow-xl bg-white p-3 flex flex-col mx-auto">
            <h2 className="text-[13px] font-semibold text-gray-700 tracking-normal mb-2">Payment Method</h2>
            <div>
                <div className="flex gap-1">
                    {PAYMENT_METHODS.map((method) => (
                        <div key={method.key} className="relative group flex-1">
                            <button
                                onClick={() => setPaymentMethod(method.key)}
                                className={`w-full flex items-center justify-center px-2.5 py-1.5 rounded-md border transition-colors text-xs font-medium
                                    ${paymentMethod === method.key
                                        ? 'bg-white text-accent font-bold shadow-sm'
                                        : 'border-gray-300 text-gray-500 bg-bgLight hover:bg-gray-100'}
                                `}
                                style={paymentMethod === method.key ? { borderColor: currentTheme.color, boxShadow: `0 0 0 1px ${currentTheme.color}` } : {}}
                            >
                                {methodIcons[method.key]}
                                {method.label}
                            </button>
                            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-10 whitespace-nowrap">
                                {methodTooltips[method.key]}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </aside>
    );
}
